import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {loadAllBrands} from "../../../../redux/slices/dynamicElementsSlice";
import BrandLoader, {BrandError} from "./BrandLoader";
import BrandCard from "./BrandCard";
import ScrollLayout from "../../../../components/ScrollLayout";
import {ComponentNoData} from "../../../../components/ComponentLoader";
import ViewAllTitle from "../../../../components/ViewAllTitle";

const AllBrands = ({hasViewAllBtn = true, featured = true, mobile}) => {

  const dispatch = useDispatch();
  const {loading, data, init, error, hasNext} =
    useSelector((state) => state.dynamicElements[featured ? 'featuredBrands' : 'allBrands']);

  useEffect(() => {
    if (!init && !loading && !error)
      loadMore(true);
  }, [dispatch, init, loading, error]);

  const loadMore = (force = false) => {
    if (force || (hasNext && !loading && !error))
      dispatch(loadAllBrands({featured: featured}));
  };

  const retry = () => {
    loadMore(true);
  };

  const onScrollEnd = () => {
    loadMore();
  };

  return (
    <div className={`app-top-mg w-full text-rand-100 box-border${featured ? ' app-side-pd' : ' pl-3'}`}>
      <div
        className={featured ? '' : mobile ? 'left-shadow bg-white py-3 rounded-l-[var(--border-radius)]' : 'left-shadow bg-white py-3 rounded-l-[var(--border-radius)]'}>

        {/*<div className={`text-rand-100 mb-1 flex items-center justify-between${featured ? " mx-5" : " ml-2 mr-8"}`}>*/}
        {/*  <div className="font-prata">{featured ? 'Featured Brands' : 'Brands'}</div>*/}
        {/*  {hasViewAllBtn && <div className="text-secondary-500 text-xs cursor-pointer">View all</div>}*/}
        {/*</div>*/}
        <ViewAllTitle title={featured ? 'Featured Brands' : 'Brands'} mobile={mobile}/>

        {(init && !data.length) ?
          <ComponentNoData/> :

          <ScrollLayout className="brand-list" onScroll={onScrollEnd} showNav={!mobile} classNav="mx-8">

            {data.map((d) => <BrandCard brand={d} key={d.id} isFeatured={featured} mobile={mobile}/>)}

            {Array.from({length: !init && !error ? 15 : loading ? 2 : 0}, (_, i) =>
              <BrandLoader key={`all-brand-loader-${featured ? 'featured' : 'all'}-${i}`} isFeatured={featured}/>)}
            {error && <BrandError retry={retry} errorMsg={error} isFeatured={featured}/>}

          </ScrollLayout>}

      </div>

    </div>

  );
};

export default React.memo(AllBrands);